export default __webpack_public_path__ + "static/media/MicrosoftTeams-image-(8)-375X550.839c1eb1.png";